import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import HotWorks from "@/pages/home/components/HotWorks";
import LatestNews from "@/pages/home/components/LatestNews";
import StatsBand from "@/pages/home/components/StatsBand";
import IntroSection from "@/pages/home/components/IntroSection";

export default function Home() {
  return (
    <div>
      <h1 className="sr-only">叶山小百合影视资料站 - 影视作品大全与最新资讯</h1>

      <HeroCarousel />

      <div className="max-w-7xl mx-auto w-full px-4 md:px-8 py-14 md:py-20 space-y-16 md:space-y-24">
        <section>
          <div className="mb-8">
            <p className="text-xs md:text-sm font-medium text-accent-700 tracking-widest mb-2">
              CATEGORIES
            </p>
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-semibold text-foreground-950">
              作品分类快捷入口
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按电影与电视剧两大类型快速浏览叶山小百合的完整作品列表。
            </p>
          </div>
          <CategoryEntries />
        </section>

        <StatsBand />

        <HotWorks />

        <LatestNews />

        <IntroSection />
      </div>
    </div>
  );
}